import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RegelSetActie } from '../../models/RegelSetActie';
import { RegelsService } from '../../services/regels.service';

@Component({
  selector: 'app-regel-set-actie-dialog',
  templateUrl: './regel-set-actie-dialog.component.html',
  styleUrls: ['./regel-dialog.component.scss']
})
export class RegelSetActieDialogComponent implements OnInit {
  action: string;
  local_data: any;
  beschikbareRegelSetActieTypes: string[];

  constructor(
    private regelsSvc: RegelsService,
    public dialogRef: MatDialogRef<RegelSetActieDialogComponent>,
    //@Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: RegelSetActie
  ) {
    console.log(data);
    this.local_data = { ...data };
    this.action = this.local_data.action;
  }

  ngOnInit(): void {
    this.regelsSvc.beschikbareRegelSetActieTypes().subscribe((t) => {
      this.beschikbareRegelSetActieTypes = t;
    });
  }

  doAction() {
    this.dialogRef.close({ event: this.action, data: this.local_data });
  }

  closeDialog() {
    this.dialogRef.close({ event: 'Annuleren' });
  }
}
